<template>
  <div>
    <div class="mt-component-form">
      <vs-row class="my-4">
        <vs-col
          ><h5><i class="dot"></i>기본정보</h5></vs-col
        >
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">회사명</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_1 }}</p>
          <ml-input
            v-else
            v-model="form.inputA_1"
            class="w-full flex-1"
            :readonly="true"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">소속</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_0 }}</p>
          <ml-input
            v-else
            class="w-full flex-1"
            v-model="form.inputA_0"
            :readonly="true"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">부서</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_2 }}</p>
          <ml-input
            v-else
            v-model="form.inputA_2"
            class="w-full flex-1"
            :readonly="true"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">작성자</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_3 }}</p>
          <ml-input
            v-else
            v-model="form.inputA_3"
            class="w-full flex-1"
            :readonly="true"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">점검일</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_4 }}</p>
          <date-selector
            :readonly="board.readonly"
            v-else
            v-model="form.inputA_4"
            class="w-full flex-1"
          />
        </div>
      </div>
    </div>
    <div class="mt-component-form">
      <vs-row class="my-4">
        <vs-col
          ><h5><i class="dot"></i>관련내용</h5></vs-col
        >
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
        <div class="col-span-12 flex items-start">
          <div class="label-text mr-4 mt-2">점검내용</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputB_1 }}</p>
          <ml-textarea
            :readonly="board.readonly"
            v-else
            v-model="form.inputB_1"
            class="flex-1 w-full"
            rows="5"

          />
        </div>
      </div>
    </div>
    <file-upload-module
      :readonly="board.readonly"
      class="w-full "
      v-if="!isPrint"
      v-model="form.fileList"
    />
  </div>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector.vue";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
export default {
  components: { DateSelector, DisasterClassSelector, FileUploadModule },
  name: "Write",
  props: {
    board: Object,
    value: Object,
    isPrint: {
      type: Boolean
    }
  },
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.inputA_1 =
          this.value && this.value.inputA_1
            ? this.value.inputA_1
            : this.board.projectTitle;
        this.form.inputA_2 =
          this.value && this.value.inputA_2
            ? this.value.inputA_2
            : this.board.writer.com_name;
        this.form.inputA_3 =
          this.value && this.value.inputA_3
            ? this.value.inputA_3
            : this.board.writer.name;
        this.form.inputA_0 =
          this.value && this.value.inputA_0
            ? this.value.inputA_0
            : this.board.writer.department;
      }
    },
    value(value) {
      const keys = Object.keys(this.form);
      for (const key of keys) {
        this.form[key] = value[key];
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = value.inputA_1;
        value.summary = {
          "점검표": [{'TAC 안전관리 점검표': 1}]
        }
        this.$emit("input", value);
      }
    }
  },
  data() {
    return {
      form: {
        fileList: [],
        inputA_0: "",
        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",

        inputB_1: ""
      }
    };
  }
};
</script>

<style scoped>
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}
</style>
